<template>
  <section>
    <div class="user-main awaitorder">
      <div class="user-cont layui-card">
        <div class="tabs flex">
          <li @click="changetab('0')" :class="isexpire==0?'active':''">待结算订单</li>
          <li @click="changetab('1')" :class="isexpire==1?'active':''">已过期</li>
          <li @click="changetab('2')" :class="isexpire==2?'active':''">未过期</li>
          <div class="flex ju-be">
            <div class="block">
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="datefrom"
                type="date"
                placeholder="选择开始日期时间"
              ></el-date-picker>
            </div>
            <div class="block blockendTime">
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="dateto"
                type="date"
                placeholder="选择结束日期时间"
              ></el-date-picker>
            </div>
            <el-button type="primary" size="small" class="exportantOrder" @click="searchReg">查询</el-button>
            <el-button
              round
              type="primary"
              size="small"
              class="exportantOrder"
              @click="exportantOrder"
            >导出订单</el-button>
          </div>
        </div>
      </div>
      <el-table
        ref="multipleTable"
        :span-method="arraySpanMethod"
        :data="jiesuanorder.data"
        border
        tooltip-effect="dark"
        style="width: 95%;margin:auto"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="40" label="全选" :selectable='selectInit'></el-table-column>
        <el-table-column prop="addtime" label="下单时间"></el-table-column>
        <el-table-column prop="orderno" label="订单号">
          <template slot-scope="scope">
            <div>{{scope.row.orderno}}</div>
            <div v-if="scope.row.isauthpaid==2" class="color-primary">待审核</div>
          </template>
        </el-table-column>
        <el-table-column prop="total" label="商品金额" width="80"></el-table-column>
        <el-table-column prop="shipfee" label="运费" width="80"></el-table-column>
        <el-table-column prop="discount" label="优惠"></el-table-column>
        <el-table-column prop="amount" label="实付款" width="80"></el-table-column>
        <el-table-column prop="nickname" label="下单人" width="80"></el-table-column>
        <el-table-column prop="departname" label="下单部门" width="80"></el-table-column>
        <el-table-column label="商品信息" width="280" class-name="tablegoodsinfo">
          <template slot-scope="scope">
            <div class="hebin" v-for="(item_i,index_i) in scope.row.detail" :key="index_i">
              <div class="clearfix cpinfo flex">
                <div class="img">
                  <a :href="'#/goodsdetail?id='+ item_i.productid" target="_blank">
                    <img :src="item_i.indexpic" />
                  </a>
                </div>
                <div class="cont flex">
                  <div class style="width:170px">
                    <div class="name ellipsis-2">{{item_i.title}}</div>
                    <div class="info">{{item_i.specnames}}</div>
                    <div class="cart-price">{{item_i.price}}*{{item_i.num}}</div>
                  </div>
                  <div class="color-primary" style="width:50px;text-align:right">{{item_i.unit}}</div>
                  <div class="color-primary" style="width:70px;text-align:right">{{item_i.price}}</div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单位" width="50"></el-table-column>
        <el-table-column label="单价" width="70"></el-table-column>
      </el-table>
      <div class="flex">
        <el-pagination
          class="fenye"
          background
          layout="prev, pager, next"
          :page-size="~~jiesuanorder.per_page"
          @current-change="currentPage"
          :total="jiesuanorder.total"
        ></el-pagination>
      </div>
      <div class="selectgroup">
        <ul class="clearlist clearfix">
          <li :class="paymethod==2?'active':''" @click="changePayMethod(2)">
            <img src="/static/images/icon_alipay.png" /> 支付宝支付
          </li>
          <li :class="paymethod==1?'active':''" @click="changePayMethod(1)">
            <img src="/static/images/icon_wxpay.png" /> 微信支付
          </li>
          <li slot="reference" :class="paymethod==3?'active':''" @click="changePayMethod(3)">对公转账</li>
        </ul>
      </div>
      <div class="totalnum flex ju-be">
        <span class="goodsnum">共{{multipleSelection.length}}个订单</span>
        <div class="submit">
          <span>合计</span>
          <span class="color-primary">￥{{(total).toFixed(2)}}</span>
          <el-button type="primary" @click="jiesuan" v-if="paymethod==3">确认结算(上传已付款的结算凭证)</el-button>
          <el-button type="primary" @click="jiesuanlinepay" v-else>确认结算(在线支付)</el-button>
        </div>
      </div>
      <div class="pinzheng" v-if="paymethod==3">
        <el-tooltip
          class="item"
          v-model="tooltip"
          :manual="tooltip"
          effect="dark"
          content="如果对公转账成功，请在此上传转账凭证，方便后台结算"
          placement="right-end"
        >
          <img :src="imageUrl" alt srcset class="pinzhengimg" />
        </el-tooltip>
        <el-upload
          class="uploadimg"
          :action="uploadimg"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          list-type="picture"
        >
          <el-button
            size="small"
            type="primary"
            class="primary_bg primary_bor"
            style="height:40px"
          >点击上传</el-button>
        </el-upload>
          <el-input type="number" v-model="payment" placeholder="请输入转款金额" style="height:40px;margin-left:10px;width:200px"></el-input>
       <div class="toastAmount color-red">温馨提示，请保持输入金额和上传凭证金额一致</div>
        <div v-html="zhuanzhang" class="dgzhbox"></div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "AwaitOrder",
  inject: ["reload"], //注入reload方法
  data() {
    return {
      checked: false,
      payment: "",
      uploadimg: sessionStorage.baseUrl + "app/file/upload",
      isexpire: 0,
      jiesuanorder: { data: [] },
      page: 1,
      tooltip: true,
      pagesize: "10",
      imageUrl: "",
      zhuanzhang: "",
      total: 0,
      datefrom: "",
      dateto: "",
      paymethod: 2,
      ids: [],
      multipleSelection: []
    };
  },
  props: {
    showtab: {
      type: String
    }
  },
  watch: {
    multipleSelection(val) {
      let total = 0;
      let ids = [];
      for (let i = 0; i < val.length; i++) {
        total = total + parseFloat(val[i].amount);
        ids.push(val[i].id);
      }
      this.total = total;
      this.ids = ids;
      console.log("totaltotal", total);
    }
  },
  methods: {
    changePayMethod(type) {
      this.paymethod = type;
    },
    async getjiesuanorder() {
      let res = await await this.$fetch("order/ordertopay", {
        body: {
          page: this.page,
          datefrom: this.datefrom,
          dateto: this.dateto,
          isauthpaid: 0,
          pagesize: this.pagesize,
          isexpire: this.isexpire
        }
      });
      this.jiesuanorder = res;
    },
    searchReg() {
      this.getjiesuanorder();
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 9) {
        return [1, 3];
      } else if (columnIndex === 10) {
        return [0, 0];
      } else if (columnIndex === 11) {
        return [0, 0];
      }
    },
    async jiesuan() {
      //结算订单
      if (!this.imageUrl) {
        this.$message.error("请上传凭证");
        return;
      }
      if (!this.payment || this.payment < this.total) {
        this.$message.error(`转款金额必须大于等于${this.total}元`);
        return;
      }
      let result = await this.yanzheng("授信");
      if (result) {
        this.$alert('您的订单结算凭证已提交成功，请等待后台审核结算，我们确认无误后，会恢复您的授信金额，到时您可以继续下单，谢谢！', '温馨提示');
        this.reload(); //直接调用
      }
       
    },

    async exportantOrder() {
      if (this.jiesuanorder.data.length == 0) {
        this.$message.error("当前状态下无订单数据");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "导出中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let token = md5("jrsc");
      let guid = sessionStorage.guid;
      let base =
        sessionStorage.baseUrl +
        "app/order/ordertopay?" +
        `token=${token}` +
        `&guid=${guid}` +
        `&page=${this.page}&export=1&pagesize=${this.pagesize}&datefrom=${this.datefrom}&dateto=${this.dateto}&isexpire=${this.isexpire}`;
      location.href = base;
      loading.close();
    },
    async jiesuanlinepay() {
      let result = await this.yanzheng(this.paymethod == 1 ? "微信" : "支付宝");
      if (result) {
        this.$router.push(
          `jieguo?orderno=${result}_2&paymethod=${this.paymethod}&routertype=6-7`
        );
        this.getjiesuanorder();
      }
    },
    async yanzheng(paytype) {
      if (this.multipleSelection.length == 0) {
        this.$message.error("请选择订单");
        return;
      }
      let res = await this.$fetch("order/orderbatchpay", {
        body: {
          amount: this.total,
          paytype,
          payuser: "~~",
          photos: [this.imageUrl],
          ids: this.ids.join(",")
        }
      });
      if (res) {
        this.$message({
          type: "success",
          message: "提交成功"
        });
      }
      return res;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection)
    },
      selectInit(row,index){
        if(row.isauthpaid==2){
            return false  //不可勾选
        }else{    
            return true  //可勾选
        }
   },
    changetab(type) {
      // 改变tab
      this.page = 1;
      this.isexpire = type;
      this.getjiesuanorder();
    },
    currentPage(e) {
      this.page = e;
      this.getjiesuanorder();
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.msg;
      // console.log(res, file)
    }

    // changetab()
  },
  async mounted() {
    this.getjiesuanorder();
    this.zhuanzhang = await this.$fetch("index/label", {
      params: "&name=transfer_account"
    });
  }
};
</script>

<style lang='scss' scoped>
.zhuanzhang {
  min-width: 600px !important;
  button {
    height: 30px;
    box-sizing: border-box;
    line-height: 30px;
    padding: 0;
    padding-bottom: 0;
  }
}
.blockendTime {
  margin: 0 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/awaitOrder.vue